import { CommonModule } from '@angular/common';
import { Component, ComponentFactoryResolver, ComponentRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { ContextMenuItemEvent } from 'src/app/components/api-configurations/common/models/context-menu-item-event';
import { MultiLevelContextMenuItem } from 'src/app/components/api-configurations/common/models/multi-level-context-menu-item';
import { MultiLevelContextMenuComponent } from 'src/app/components/api-configurations/common/multi-level-context-menu/multi-level-context-menu.component';
import { WorkflowConditionTypes } from 'src/app/components/designer/models/Enums/workflow-condition-types';
import { ActivatedStepsConditionData } from 'src/app/components/designer/models/activated-steps-condition-data';
import { AttributeValueConditionData } from 'src/app/components/designer/models/attribute-value-condition-data';
import { AttributesMustBeFilledInConditionData } from 'src/app/components/designer/models/attributes-must-be-filled-in-condition-data';
import { BaseConditionData } from 'src/app/components/designer/models/base-condition-data';
import { CompletedStepsConditionData } from 'src/app/components/designer/models/completed-steps-condition-data';
import { DefaultConditionData } from 'src/app/components/designer/models/default-condition-data';
import { LogicalExpressionConditionData } from 'src/app/components/designer/models/logical-expression-condition-data';
import { MandatoryAttributesMustBeFilledInConditionData } from 'src/app/components/designer/models/mandatory-attributes-must-be-filled-in-condition-datas';
import { StepSpecificStateConditionData } from 'src/app/components/designer/models/step-specific-state-condition-datas';
import { FormMode } from 'src/app/controls/common/form-mode';
import { NeedAttributes } from 'src/app/controls/workflows/need-attributes';
import { NeedConditions } from 'src/app/controls/workflows/need-conditions';
import { NeedCustomers } from 'src/app/controls/workflows/need-customers';
import { NeedFolderStates } from 'src/app/controls/workflows/need-folder-states';
import { NeedSteps } from 'src/app/controls/workflows/need-steps';
import { NeedUsers } from 'src/app/controls/workflows/need-users';
import { WorkflowDataDirective } from 'src/app/controls/workflows/workflow-data.directive';
import { WorkflowDataInterface } from 'src/app/controls/workflows/workflow-data.interface';
import { ComparaisonOperator } from 'src/app/models/RestApiCaller/Enums/comparaison-operator';
import { DataType } from 'src/app/models/RestApiCaller/Enums/data-type';
import { AttributeDefinitionsService } from 'src/app/services/attribute-definitions.service';
import { CustomersService } from 'src/app/services/customers.service';
import { FoldersStatesService } from 'src/app/services/folders-states.service';
import { UsersService } from 'src/app/services/users.service';
import { WorkflowConditionFormDialogData } from '../Models/workflow-condition-form-dialog-data';
import { WorkflowConditionFormDialogResult } from '../Models/workflow-condition-form-dialog-result';
import { WorkflowConditionAttributeValueDataComponent } from './workflow-condition-attribute-value-data/workflow-condition-attribute-value-data.component';
import { WorkflowConditionAttributesMustBeFilledInDataComponent } from './workflow-condition-attributes-must-be-filled-in-data/workflow-condition-must-be-filled-in-data.component';
import { WorkflowConditionLogicalExpressionDataComponent } from './workflow-condition-logical-expression-data/workflow-condition-logical-expression-data.component';
import { WorkflowConditionStepActivatedDataComponent } from './workflow-condition-step-activated-data/workflow-condition-step-activated-data.component';
import { WorkflowConditionStepCompletedDataComponent } from './workflow-condition-step-completed-data/workflow-condition-step-completed-data.component';
import { WorkflowConditionStepSpecificStateDataComponent } from './workflow-condition-step-specific-state-data/workflow-condition-step-specific-state-data.component';

@Component({
    selector: 'app-workflow-condition-form-dialog',
    imports: [
        MatCardModule,
        FormsModule,
        MatFormFieldModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        CommonModule,
        ReactiveFormsModule,
        WorkflowDataDirective,
        MultiLevelContextMenuComponent,
    ],
    templateUrl: './workflow-condition-form-dialog.component.html',
    styleUrl: './workflow-condition-form-dialog.component.scss',
})
export class WorkflowConditionFormDialogComponent implements OnInit {
    WorkflowConditionTypes = WorkflowConditionTypes;
    public item: BaseConditionData;
    public title: string;

    public conditionTypes: { value: number; name: string }[] = [
        { value: WorkflowConditionTypes.AttributeValue, name: "La valeur d'un attribut doit respecter une condition" },
        { value: WorkflowConditionTypes.AttributesMustBeFilledIn, name: 'Des attributs doivent être renseignés' },
        { value: WorkflowConditionTypes.LogicalExpression, name: 'Une expression logique soit être respectée' },
        { value: WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn, name: 'Les attributs obligatoires doivent être renseignés' },
        { value: WorkflowConditionTypes.StepActivated, name: 'Des étapes doivent être actives' },
        { value: WorkflowConditionTypes.StepCompleted, name: 'Des étapes doivent être closes' },
        { value: WorkflowConditionTypes.StepSpecificState, name: 'Une étape doit être dans un état particulier' },
        // { value: RestApiConditionType.Variable, name: 'Variable' },
        // { value: RestApiConditionType.Logical, name: 'Expression logique' },
    ];

    public comparaisons: { value: string; name: string }[] = [
        { value: ComparaisonOperator.Equality, name: 'Egal à' },
        { value: ComparaisonOperator.GreaterOrEqualThan, name: 'Supériueur ou égal à' },
        { value: ComparaisonOperator.GreaterThan, name: 'Supérieur à' },
        { value: ComparaisonOperator.Inequality, name: 'Différent de' },
        { value: ComparaisonOperator.LessOrEqualThan, name: 'Inférieur ou égal à' },
        { value: ComparaisonOperator.LessThan, name: 'Inférieur à' },
    ];

    public datasType: { value: string; name: string }[] = [
        { value: DataType.Text, name: 'Texte' },
        { value: DataType.Integer, name: 'Nombre entier' },
        { value: DataType.Decimal, name: 'Nombre décimal' },
        { value: DataType.Date, name: 'Date' },
    ];

    // public responseVariables: { id: number; name: string }[] = [];

    public referenceConditions: BaseConditionData[] = [];

    /**
     * Liste des éléments du menu contextuel.
     */
    contextMenuItems: MultiLevelContextMenuItem = null;

    /**
     * Instance du contrôle pour lequel est ouvert le menu contextuel.
     */
    currentContextMenuControl: AbstractControl;

    /**
     * Index du début du texte sélectionné dans le champ (utilisé pour le placement d'une variable avec le menu contextuel).
     */
    currentSelectionStart: number;

    /**
     * Index de fin du texte sélectionné dans le champ sujet (utilisé pour le placement d'une variable avec le menu contextuel).
     */
    currentSelectionEnd: number;

    /**
     * Position horizontale de la sourris au moment d'un clic droit (utilisé pour positionner le menu contextuel)
     */
    rightClickMenuPositionX: number;

    /**
     * Position verticale de la sourris au moment d'un clic droit (utilisé pour positionner le menu contextuel)
     */
    rightClickMenuPositionY: number;

    /**
     * Valeur indiquant si le menu contextuel est visible.
     */
    isContextMenuVisible: boolean;

    conditionForm: FormGroup;

    @ViewChild(WorkflowDataDirective, { static: true })
    workflowDataHost!: WorkflowDataDirective;

    /**
     * Reference au composant du menu contextuel
     */
    @ViewChild(MultiLevelContextMenuComponent)
    contextMenu: MultiLevelContextMenuComponent;

    componentRef: ComponentRef<WorkflowDataInterface>;

    constructor(
        private attributesService: AttributeDefinitionsService,
        private foldersStatesService: FoldersStatesService,
        private usersService: UsersService,
        protected customersService: CustomersService,
        private spinner: NgxSpinnerService,
        private componentFactoryResolver: ComponentFactoryResolver,
        public dialogRef: MatDialogRef<WorkflowConditionFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: WorkflowConditionFormDialogData
    ) {
        this.title = data.title;
        //this.contextMenuItems = data.contextMenuItems;
        this.cloneCondition(data.item);
        // this.responseVariables = data.variables.map((x) => {
        //     return { id: x.id, name: x.name };
        // });

        // this.contextMenuItems = data.referencedConditions.map((x) => {
        //     return new VariableContextMenuItem(`${x.name}`, `{${x.name}}`);
        // });

        let conditionMenuItems: MultiLevelContextMenuItem[] = data.referencedConditions.map((x) => {
            return new MultiLevelContextMenuItem(x.name, `C${x.id}`);
        });

        this.contextMenuItems = new MultiLevelContextMenuItem('Root', null, conditionMenuItems);

        this.conditionForm = new FormGroup({
            name: new FormControl(''),
            description: new FormControl(''),
            conditionType: new FormControl(''),
            comparaisonOperator: new FormControl(''),
            variableName: new FormControl(''),
            dataType: new FormControl(''),
            value: new FormControl(''),
            expression: new FormControl(''),
        });

        if (data.readonly) {
            this.conditionForm.disable();
        }

        this.fillForm(this.item);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit() {
        this.loadDataComponent();
    }

    onConfirm(): void {
        this.RetrieveValueFromForm();
        let result: WorkflowConditionFormDialogResult = { status: true, item: this.item };

        // Close the dialog, return true
        this.dialogRef.close(result);
    }

    onCancel(): void {
        let result: WorkflowConditionFormDialogResult = { status: false, item: this.item };
        // Close the dialog, return false
        this.dialogRef.close(result);
    }

    /**
     * Levé lorsque l'utilisateur fait un clic-droit sur un champ de saisie.
     * @param event : Événement souris.
     */
    public onInputRightClick(event: MouseEvent) {
        this.isContextMenuVisible = true;

        // Position de la souris utilisé pour placer le menu contextuel.
        this.rightClickMenuPositionX = event.clientX;
        this.rightClickMenuPositionY = event.clientY;

        // Récupère la sélection dans le champ Input. Le paramètre remplacera cette selection.
        this.currentSelectionStart = event.target['selectionStart'];
        this.currentSelectionEnd = event.target['selectionEnd'];

        this.contextMenu.openMenu('dynamic', event);
    }

    /**
     * Ferme le menu contextuel.
     */
    public CloseContextMenu() {
        this.isContextMenuVisible = false;
    }

    public onConditionTypeChanged(event: MatSelectChange) {
        console.log('WorkflowConditionFormDialogComponent - onConditionTypeChanged', event);
        let id = this.item?.id;
        let isMainCondition = this.item?.isMainCondition;

        switch (event.value) {
            case WorkflowConditionTypes.None:
                break;
            case WorkflowConditionTypes.AttributeValue:
                this.item = new AttributeValueConditionData();
                break;
            case WorkflowConditionTypes.AttributesMustBeFilledIn:
                this.item = new AttributesMustBeFilledInConditionData();
                break;
            case WorkflowConditionTypes.LogicalExpression:
                this.item = new LogicalExpressionConditionData();
                break;
            case WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn:
                this.item = new MandatoryAttributesMustBeFilledInConditionData();
                break;
            case WorkflowConditionTypes.StepActivated:
                this.item = new ActivatedStepsConditionData();
                break;
            case WorkflowConditionTypes.StepCompleted:
                this.item = new CompletedStepsConditionData();
                break;
            case WorkflowConditionTypes.StepSpecificState:
                this.item = new StepSpecificStateConditionData();
                break;
        }

        this.item.id = id;
        this.item.isMainCondition = isMainCondition;

        this.loadDataComponent();
    }

    /**
     * Levé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement clic du menu contextuel.
     */
    // handleMenuItemClick(event: VariableContextMenuItemEvent) {
    //     let expressionControl = this.conditionForm.get('expression');

    //     if (expressionControl.value) {
    //         expressionControl.setValue(
    //             expressionControl.value.substring(0, this.currentSelectionStart) + event.variable + expressionControl.value.substring(this.currentSelectionEnd)
    //         );
    //     } else {
    //         expressionControl.setValue(event.variable);
    //     }

    //     this.isContextMenuVisible = false;
    // }
    handleMenuItemClick(event: ContextMenuItemEvent) {
        if (this.currentContextMenuControl.value) {
            this.currentContextMenuControl.setValue(
                this.currentContextMenuControl.value.substring(0, this.currentSelectionStart) +
                    event.data +
                    this.currentContextMenuControl.value.substring(this.currentSelectionEnd)
            );
        } else {
            this.currentContextMenuControl.setValue(event.data);
        }

        this.isContextMenuVisible = false;
    }

    /**
     * Retourne la valeur du formulaire.
     */
    RetrieveValueFromForm() {
        switch (this.conditionForm.get('conditionType').value) {
            case WorkflowConditionTypes.None:
                break;
            case WorkflowConditionTypes.AttributeValue:
                let attributeValueConditionData = new AttributeValueConditionData();
                if (this.item) {
                    // Cas autre que la création.
                    attributeValueConditionData.id = this.item.id;
                    attributeValueConditionData.isMainCondition = this.item.isMainCondition;
                }
                attributeValueConditionData.name = this.conditionForm.get('name').value;
                attributeValueConditionData.attributeId = (this.componentRef.instance as WorkflowConditionAttributeValueDataComponent).data.attributeId;
                attributeValueConditionData.comparaisonValue = (this.componentRef.instance as WorkflowConditionAttributeValueDataComponent).data.comparaisonValue;
                attributeValueConditionData.comparisonType = (this.componentRef.instance as WorkflowConditionAttributeValueDataComponent).data.comparisonType;
                this.item = attributeValueConditionData;
                break;
            case WorkflowConditionTypes.AttributesMustBeFilledIn:
                let attributesMustBeFilledInConditionData = new AttributesMustBeFilledInConditionData();
                if (this.item) {
                    // Cas autre que la création.
                    attributesMustBeFilledInConditionData.id = this.item.id;
                    attributesMustBeFilledInConditionData.isMainCondition = this.item.isMainCondition;
                }
                attributesMustBeFilledInConditionData.name = this.conditionForm.get('name').value;
                attributesMustBeFilledInConditionData.attributes = (this.componentRef.instance as WorkflowConditionAttributesMustBeFilledInDataComponent).data.attributes;
                this.item = attributesMustBeFilledInConditionData;
                break;
            case WorkflowConditionTypes.LogicalExpression:
                let logicalExpressionConditionData = new LogicalExpressionConditionData();
                if (this.item) {
                    // Cas autre que la création.
                    logicalExpressionConditionData.id = this.item.id;
                    logicalExpressionConditionData.isMainCondition = this.item.isMainCondition;
                }
                logicalExpressionConditionData.name = this.conditionForm.get('name').value;
                logicalExpressionConditionData.expression = (this.componentRef.instance as WorkflowConditionLogicalExpressionDataComponent).data.expression;
                this.item = logicalExpressionConditionData;
                break;
            case WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn:
                let mandatoryAttributesMustBeFilledInConditionData = new MandatoryAttributesMustBeFilledInConditionData();
                if (this.item) {
                    // Cas autre que la création.
                    mandatoryAttributesMustBeFilledInConditionData.id = this.item.id;
                    mandatoryAttributesMustBeFilledInConditionData.isMainCondition = this.item.isMainCondition;
                }
                mandatoryAttributesMustBeFilledInConditionData.name = this.conditionForm.get('name').value;
                this.item = mandatoryAttributesMustBeFilledInConditionData;
                break;
            case WorkflowConditionTypes.StepActivated:
                let activatedStepsConditionData = new ActivatedStepsConditionData();
                if (this.item) {
                    // Cas autre que la création.
                    activatedStepsConditionData.id = this.item.id;
                    activatedStepsConditionData.isMainCondition = this.item.isMainCondition;
                }
                activatedStepsConditionData.name = this.conditionForm.get('name').value;
                activatedStepsConditionData.steps = (this.componentRef.instance as WorkflowConditionStepActivatedDataComponent).data.steps;
                this.item = activatedStepsConditionData;
                break;
            case WorkflowConditionTypes.StepCompleted:
                let completedStepsConditionData = new CompletedStepsConditionData();
                if (this.item) {
                    // Cas autre que la création.
                    completedStepsConditionData.id = this.item.id;
                    completedStepsConditionData.isMainCondition = this.item.isMainCondition;
                }
                completedStepsConditionData.name = this.conditionForm.get('name').value;
                completedStepsConditionData.steps = (this.componentRef.instance as WorkflowConditionStepCompletedDataComponent).data.steps;
                this.item = completedStepsConditionData;
                break;
            case WorkflowConditionTypes.StepSpecificState:
                let stepSpecificStateConditionData = new StepSpecificStateConditionData();
                if (this.item) {
                    // Cas autre que la création.
                    stepSpecificStateConditionData.id = this.item.id;
                    stepSpecificStateConditionData.isMainCondition = this.item.isMainCondition;
                }
                stepSpecificStateConditionData.name = this.conditionForm.get('name').value;
                stepSpecificStateConditionData.stepId = (this.componentRef.instance as WorkflowConditionStepSpecificStateDataComponent).data.stepId;
                stepSpecificStateConditionData.stateId = (this.componentRef.instance as WorkflowConditionStepSpecificStateDataComponent).data.stateId;
                this.item = stepSpecificStateConditionData;
                break;
            // case RestApiConditionType.Variable:
            //     let variableDatas = new VariableApiConditionDatas();
            //     variableDatas.VariableName = this.conditionForm.get('variableName').value;
            //     variableDatas.DataType = this.conditionForm.get('dataType').value;
            //     variableDatas.Operator = this.conditionForm.get('comparaisonOperator').value;
            //     variableDatas.Value = this.conditionForm.get('value').value;
            //     this.item.variableApiConditionDatas = variableDatas;
            //     break;
            // case RestApiConditionType.Logical:
            //     let logicalDatas = new LogicalConditionDatas();
            //     logicalDatas.Expression = this.convertExpressionFromForm(this.conditionForm.get('expression').value);
            //     this.item.logicalConditionDatas = logicalDatas;
            //     break;
        }
    }

    /**
     * Remplit les champs du formulaire avec les données de la condition.
     */
    private fillForm(item: BaseConditionData) {
        if (item) {
            // this.conditionForm.get('name').setValue(item.name);
            // this.conditionForm.get('description').setValue(item.description);
            this.conditionForm.get('conditionType').setValue(item.type);

            switch (item.type) {
                case WorkflowConditionTypes.None:
                    break;
                case WorkflowConditionTypes.AttributeValue:
                    this.conditionForm.get('name').setValue((item as AttributeValueConditionData).name);
                    break;
                case WorkflowConditionTypes.AttributesMustBeFilledIn:
                    this.conditionForm.get('name').setValue((item as AttributesMustBeFilledInConditionData).name);
                    break;
                case WorkflowConditionTypes.LogicalExpression:
                    this.conditionForm.get('name').setValue((item as LogicalExpressionConditionData).name);
                    break;
                case WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn:
                    this.conditionForm.get('name').setValue((item as MandatoryAttributesMustBeFilledInConditionData).name);
                    break;
                case WorkflowConditionTypes.StepActivated:
                    this.conditionForm.get('name').setValue((item as ActivatedStepsConditionData).name);
                    break;
                case WorkflowConditionTypes.StepCompleted:
                    this.conditionForm.get('name').setValue((item as CompletedStepsConditionData).name);
                    break;
                case WorkflowConditionTypes.StepSpecificState:
                    this.conditionForm.get('name').setValue((item as StepSpecificStateConditionData).name);
                    break;
                // case RestApiConditionType.Variable:
                //     this.conditionForm.get('variableName').setValue(item.variableApiConditionDatas.VariableName);
                //     this.conditionForm.get('dataType').setValue(item.variableApiConditionDatas.DataType);
                //     this.conditionForm.get('comparaisonOperator').setValue(item.variableApiConditionDatas.Operator);
                //     this.conditionForm.get('value').setValue(item.variableApiConditionDatas.Value);
                //     break;
                // case RestApiConditionType.Logical:
                //     this.conditionForm.get('expression').setValue(this.convertExpressionFromData(item.logicalConditionDatas.Expression));
                //     break;
            }
        }
    }

    // private convertExpressionFromForm(expression: string): string {
    //     let convertedExpression = `${expression}`;
    //     var regex = /{([\w\s\-_])+}/g;

    //     let match;

    //     while ((match = regex.exec(expression)) !== null) {
    //         var conditionName = match[0];
    //         console.log('conditionName', conditionName);
    //         var conditionReference = this.data.referencedConditions.find((x) => `{${x.name}}` === conditionName).id;
    //         console.log('conditionReference', conditionReference);
    //         convertedExpression = convertedExpression.replace(conditionName, `{C${conditionReference}}`);
    //     }

    //     return convertedExpression;
    // }

    // private convertExpressionFromData(expression: string): string {
    //     let convertedExpression = `${expression}`;
    //     var regex = /{(C\d+)+}/g;

    //     let match;

    //     while ((match = regex.exec(expression)) !== null) {
    //         var conditionReference = match[0];
    //         console.log('conditionReference', conditionReference);
    //         var conditionName = this.data.referencedConditions.find((x) => `{C${x.id}}` === conditionReference).name;
    //         console.log('conditionName', conditionName);
    //         convertedExpression = convertedExpression.replace(conditionReference, `{${conditionName}}`);
    //     }

    //     return convertedExpression;
    // }

    private cloneCondition(condition: BaseConditionData) {
        if (condition) {
            switch (condition.type) {
                case WorkflowConditionTypes.None:
                    this.item = DefaultConditionData.clone(condition as DefaultConditionData);
                    break;
                case WorkflowConditionTypes.AttributeValue:
                    this.item = AttributeValueConditionData.clone(condition as AttributeValueConditionData);
                    break;
                case WorkflowConditionTypes.AttributesMustBeFilledIn:
                    this.item = AttributesMustBeFilledInConditionData.clone(condition as AttributesMustBeFilledInConditionData);
                    break;
                case WorkflowConditionTypes.LogicalExpression:
                    this.item = LogicalExpressionConditionData.clone(condition as LogicalExpressionConditionData);
                    break;
                case WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn:
                    this.item = MandatoryAttributesMustBeFilledInConditionData.clone(condition as MandatoryAttributesMustBeFilledInConditionData);
                    break;
                case WorkflowConditionTypes.StepActivated:
                    this.item = ActivatedStepsConditionData.clone(condition as ActivatedStepsConditionData);
                    break;
                case WorkflowConditionTypes.StepCompleted:
                    this.item = CompletedStepsConditionData.clone(condition as CompletedStepsConditionData);
                    break;
                case WorkflowConditionTypes.StepSpecificState:
                    this.item = StepSpecificStateConditionData.clone(condition as StepSpecificStateConditionData);
                    break;
                default:
                    console.error(`Le type de condition '${condition.type}' n'est pas implémentée.`);
                    break;
            }
        }
    }

    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected dynamicComponentDestroyed$: Subject<void> = new Subject<void>();

    private loadDataComponent() {
        const viewContainerRef = this.workflowDataHost.viewContainerRef;
        viewContainerRef.clear();
        this.dynamicComponentDestroyed$.next();

        switch (this.conditionForm.get('conditionType').value) {
            case 1: // None
                // this.componentRef = viewContainerRef.createComponent<WorkflowConditionNoneDataComponent>(
                //     this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionNoneDataComponent)
                // );
                // console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionNoneDataComponent');
                break;
            case WorkflowConditionTypes.AttributeValue:
                this.componentRef = viewContainerRef.createComponent<WorkflowConditionAttributeValueDataComponent>(
                    this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionAttributeValueDataComponent)
                );

                this.componentRef.instance.mode = FormMode.Edition;

                if (this.item) {
                    this.componentRef.instance.data = this.item as AttributeValueConditionData;
                }

                console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionAttributeValueDataComponent');
                break;
            case WorkflowConditionTypes.AttributesMustBeFilledIn:
                this.componentRef = viewContainerRef.createComponent<WorkflowConditionAttributesMustBeFilledInDataComponent>(
                    this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionAttributesMustBeFilledInDataComponent)
                );

                this.componentRef.instance.mode = FormMode.Edition;

                if (this.item) {
                    this.componentRef.instance.data = this.item as AttributesMustBeFilledInConditionData;
                }

                console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionAttributesMustBeFilledInDataComponent');
                break;
            case WorkflowConditionTypes.LogicalExpression:
                this.componentRef = viewContainerRef.createComponent<WorkflowConditionLogicalExpressionDataComponent>(
                    this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionLogicalExpressionDataComponent)
                );

                this.componentRef.instance.mode = FormMode.Edition;

                if (this.item) {
                    this.componentRef.instance.data = this.item as LogicalExpressionConditionData;
                }

                console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionLogicalExpressionDataComponent');
                break;
            case WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn:
                console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionChangeStepStateDataComponent');
                break;
            case WorkflowConditionTypes.StepActivated:
                this.componentRef = viewContainerRef.createComponent<WorkflowConditionStepActivatedDataComponent>(
                    this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionStepActivatedDataComponent)
                );
                (this.componentRef.instance as WorkflowConditionStepActivatedDataComponent).steps = this.data.workflow.steps;

                this.componentRef.instance.mode = FormMode.Edition;

                if (this.item) {
                    this.componentRef.instance.data = this.item as ActivatedStepsConditionData;
                }

                console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionStepActivatedDataComponent');
                break;
            case WorkflowConditionTypes.StepCompleted:
                this.componentRef = viewContainerRef.createComponent<WorkflowConditionStepCompletedDataComponent>(
                    this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionStepCompletedDataComponent)
                );
                (this.componentRef.instance as WorkflowConditionStepCompletedDataComponent).steps = this.data.workflow.steps;

                this.componentRef.instance.mode = FormMode.Edition;

                if (this.item) {
                    this.componentRef.instance.data = this.item as CompletedStepsConditionData;
                }

                console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionChangeStepStateDataComponent');
                break;
            case WorkflowConditionTypes.StepSpecificState:
                this.componentRef = viewContainerRef.createComponent<WorkflowConditionStepSpecificStateDataComponent>(
                    this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionStepSpecificStateDataComponent)
                );
                (this.componentRef.instance as WorkflowConditionStepSpecificStateDataComponent).steps = this.data.workflow.steps;

                this.componentRef.instance.mode = FormMode.Edition;

                if (this.item) {
                    this.componentRef.instance.data = this.item as StepSpecificStateConditionData;
                }

                console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionStepSpecificStateDataComponent');
                break;
            default:
                // this.componentRef = viewContainerRef.createComponent<WorkflowConditionDefaultDataComponent>(
                //     this.componentFactoryResolver.resolveComponentFactory(WorkflowConditionDefaultDataComponent)
                // );
                // console.log('WorkflowConditionFormComponent - loadDataComponent --> WorkflowConditionDefaultDataComponent');
                break;
        }

        if (this.componentRef?.instance) {
            this.componentRef.instance.contextualMenuSource.pipe(takeUntil(this.dynamicComponentDestroyed$)).subscribe((x) => {
                this.currentContextMenuControl = x.sourceControl;
                this.onInputRightClick(x.event);
            });

            if (this.IsComponentNeedAttributes()) {
                this.loadAttributes(this.componentRef.instance as unknown as NeedAttributes);
            }

            if (this.IsComponentNeedFolderStates()) {
                this.loadFolderStates(this.componentRef.instance as unknown as NeedFolderStates);
            }

            if (this.IsComponentNeedCustomers()) {
                this.loadCustomers(this.componentRef.instance as unknown as NeedCustomers);
            }

            if (this.IsComponentNeedSteps()) {
                this.loadSteps(this.componentRef.instance as unknown as NeedSteps);
            }

            if (this.IsComponentNeedConditions()) {
                (this.componentRef.instance as unknown as NeedConditions).conditions = this.data.referencedConditions;
            }

            if (this.IsComponentNeedUsers()) {
                this.loadUsers(this.componentRef.instance as unknown as NeedUsers);
            }
        }
    }

    /**
     * Charge les étape de workflow et renseigne le composant dynamique avec.
     * @param componentInstance : Instance du composant dynamique.
     */
    private loadSteps(componentInstance: NeedSteps) {
        componentInstance.steps = this.data.workflow.steps;
    }

    /**
     * Charge les attributs du workflow et renseigne le composant dynamique avec.
     * @param componentInstance : Instance du composant dynamique.
     */
    private loadAttributes(componentInstance: NeedAttributes) {
        this.spinner.show('detail-bar-spinner');
        this.attributesService.List(null, null, null, null, 0, 1000).subscribe((x) => {
            let attributes = x.value.sort((a, b) => {
                return a.header < b.header ? -1 : 1;
            });
            componentInstance.attributes = attributes;
            this.spinner.hide('detail-bar-spinner');
        });
    }

    /**
     * Charge les états de dossier et renseigne le composant dynamique avec.
     * @param componentInstance : Instance du composant dynamique.
     */
    private loadFolderStates(componentInstance: NeedFolderStates) {
        this.foldersStatesService.List(null, null, null, null, 0, 1000).subscribe((x) => {
            let folderStates = x.value.sort((a, b) => {
                return a.name < b.name ? -1 : 1;
            });
            componentInstance.folderStates = folderStates;
            this.spinner.hide('detail-bar-spinner');
        });
    }

    /**
     * Charge les utilisateurs et renseigne le composant dynamique avec.
     * @param componentInstance : Instance du composant dynamique.
     */
    private loadUsers(componentInstance: NeedUsers) {
        this.usersService.List(null, null, null, null, 0, 1000).subscribe((x) => {
            let users = x.value.sort((a, b) => {
                return a.displayName < b.displayName ? -1 : 1;
            });
            componentInstance.users = users;
            this.spinner.hide('detail-bar-spinner');
        });
    }

    /**
     * Charge les clients et renseigne le composant dynamique avec.
     * @param componentInstance : Instance du composant dynamique.
     */
    private loadCustomers(componentInstance: NeedCustomers) {
        this.spinner.show('main-spinner');
        this.customersService.List(null, null, null, null, 0, 1000).subscribe((x) => {
            let customers = x.value.sort((a, b) => {
                return a.name < b.name ? -1 : 1;
            });
            componentInstance.customers = customers;
            this.spinner.hide('main-spinner');
        });
    }

    /**
     * Retourne une valeur indiquant si le composant dynamique a besoin de la liste des états de dossier.
     * @returns True, s'il en a besoin; false autrement.
     */
    private IsComponentNeedFolderStates() {
        return 'folderStates' in this.componentRef.instance;
    }

    /**
     * Retourne une valeur indiquant si le composant dynamique a besoin de la liste des utilisateurs.
     * @returns True, s'il en a besoin; false autrement.
     */
    private IsComponentNeedUsers() {
        return 'users' in this.componentRef.instance;
    }

    /**
     * Retourne une valeur indiquant si le composant dynamique a besoin de la liste des clients.
     * @returns True, s'il en a besoin; false autrement.
     */
    private IsComponentNeedCustomers() {
        // Vérifie que le composant possède la propriété 'folderStates'.
        return 'customers' in this.componentRef.instance;
    }

    /**
     * Retourne une valeur indiquant si le composant dynamique a besoin de la liste des attributs.
     * @returns True, s'il en a besoin; false autrement.
     */
    private IsComponentNeedAttributes() {
        return 'attributes' in this.componentRef.instance;
    }

    /**
     * Retourne une valeur indiquant si le composant dynamique a besoin de la liste des conditions.
     * @returns True, s'il en a besoin; false autrement.
     */
    private IsComponentNeedConditions() {
        return 'conditions' in this.componentRef.instance;
    }

    /**
     * Retourne une valeur indiquant si le composant dynamique a besoin de la liste des étapes.
     * @returns True, s'il en a besoin; false autrement.
     */
    private IsComponentNeedSteps() {
        return 'steps' in this.componentRef.instance;
    }
}
